module.exports = __webpack_public_path__ + "img/intro1.6754d8e9.jpeg";